__turbopack_context__.v({
  "className": "iransansfont_9492966f-module__v3HjAa__className",
  "variable": "iransansfont_9492966f-module__v3HjAa__variable",
});
